export const PlatformConfig = {
  getModuleUrl: (module: string, path: string = '') => {
    const isLocal = window.location.hostname === 'localhost';
    const urls: Record<string, string> = {
      portal: isLocal ? 'http://localhost:3005' : 'https://obis-edunexus-portal.web.app',
      erp: isLocal ? 'http://localhost:3000' : 'https://obis-edunexus-erp.web.app',
      crm: isLocal ? 'http://localhost:3000' : 'https://obis-edunexus-crm.web.app',
      finance: isLocal ? 'http://localhost:3004' : 'https://obis-edunexus-finance.web.app',
      hrms: isLocal ? 'http://localhost:5173' : 'https://obis-edunexus-hrms.web.app',
    };
    const base = urls[module] || '';
    return path ? `${base}/${path}` : base;
  }
};

export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://obis-crm-api-682121323334.us-central1.run.app/api/v1';
